import { Grid } from '@mui/material';
import './AdminAppControl.scss';
import AdminAppControlKillSwitch from '../../components/AdminAppControls/AdminAppControlKillSwitch';

const AdminAppControl: React.FC = () => {
  return (
    <Grid className="app-control-admin__container">
      <AdminAppControlKillSwitch />
    </Grid>
  );
};

export default AdminAppControl;
